import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { OrderService } from 'src/app/services/order.service';
import { LibService } from '../../services/libService';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

export interface PhaseModel {
  phase: any;
  dataSource: MatTableDataSource<any>;
  filterValue: string;
}

export interface RowModel {
  row: any;
  phases: PhaseModel[];
}

@Component({
  selector: 'app-modal-manpower-hours',
  templateUrl: './modal-manpower-hours.component.html',
  styleUrls: ['./modal-manpower-hours.component.scss']
})
export class ModalManpowerHours implements OnInit {

  code: any = null;
  version: any = null;
  orderData: any = null;
  orderRows: RowModel[] = [];

  displayedColumnsPhase: string[] = [
    'userName',
    'level',
    'hours',
    'ts',
    'tsStart',
    'tsEnd',
    'cost',
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orderService: OrderService,
    private libService: LibService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    if (data) {
      this.code = data.code;
      this.version = data.version;
    }
  }

  ngOnInit(): void {
    this.libService.lockPage('Loading data...');
    this.orderService.getOrderByCodeVersion4(this.code, this.version).subscribe((response: any) => {
      this.libService.unlockPage();
      console.log(response);

      const rawOrder = response?.data?.[0] ?? response;
      this.orderData = rawOrder;
      this.orderRows = this.buildRowModels(rawOrder);
    }, (error) => {
      console.log('CATCH ERROR PATCH VALUE REQUEST', error);
      this.libService.unlockPage();
      this.toastr.error(
        this.translate.instant('LABEL.DATA_ERROR'),
        this.translate.instant('TOASTR.WARNING')
      );
    });
  }

  private buildRowModels(order: any): RowModel[] {
    if (!order?.OrdersOrderRowsRel) return [];

    return order.OrdersOrderRowsRel.map((row: any) => {
      const phases: PhaseModel[] = (row.OrderRowsOrderPhasesRel ?? []).map((phase: any) => {
        const sorted = [...(phase.OPFPHBRel ?? [])].sort((a, b) => Number(a.ts) - Number(b.ts));
        return {
          phase,
          dataSource: new MatTableDataSource<any>(sorted),
          filterValue: '',
        };
      });

      return { row, phases };
    });
  }

  applyFilter(phaseModel: PhaseModel, event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    phaseModel.filterValue = value;
    phaseModel.dataSource.filter = value.trim().toLowerCase();
  }

  getPhaseLabel(phase: any): string {
    return phase.isFreeDescription
      ? (phase.freeDescription || '-')
      : (phase.descPhase || '-');
  }

  tsToDate(ts: any): Date | null {
    if (!ts) return null;
    const num = Number(ts);
    // timestamp in secondi (10 cifre) → converti in ms
    return new Date(num < 1e12 ? num * 1000 : num);
  }
}
